/**
 * Admin Teams Migration API
 */

import type { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import type { InferSchemas } from "../../schema-inference";
import {
  MigrateTeamsWebhookBodySchema,
  MigrateTeamsWebhookResponseSchema,
  TeamsMigrationRecordSchema,
  TeamsMigrationStatusResponseSchema
} from "./schemas/teams-migration.schemas";

export const ZAdminTeamsMigration = {
  GetStatus: {
    method: "GET" as const,
    path: "/api/admin/webhook-migration/teams/status",
    Response: ApiSuccessSchema(TeamsMigrationStatusResponseSchema)
  },
  Migrate: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/teams/migrate",
    Body: MigrateTeamsWebhookBodySchema,
    Response: ApiSuccessSchema(MigrateTeamsWebhookResponseSchema)
  }
} as const;

export type TApiAdminTeamsMigration = InferSchemas<typeof ZAdminTeamsMigration>;

// ============================================================
// Convenience Type Exports
// ============================================================

export type TeamsMigrationRecord = z.infer<typeof TeamsMigrationRecordSchema>;
export type TeamsMigrationStatusResponse = z.infer<typeof TeamsMigrationStatusResponseSchema>;
